<template>
    <teleport to="#teleport-tooltip">
        <TransitionModal>
            <TooltipLayout
                v-if="tooltip && !isCustomTooltip(tooltip)"
                ref="tooltipEl"
                role="tooltip"
                @click="close"
            >
                <template #title>
                    {{ tooltip.title }}
                </template>

                <template #content>
                    <ComponentContent
                        :data="{
                            __typename: 'ComponentContent',
                            content: tooltip.content,
                        }"
                        :background="'STONE3'"
                    />
                </template>
            </TooltipLayout>
        </TransitionModal>
    </teleport>
</template>

<script setup lang="ts">
import { isCustomTooltip } from './tooltip'
import { useTooltip } from '@/components/layout/tooltip/useTooltip'

import ComponentContent from '@/components/cms/component/ComponentContent.vue'
import TransitionModal from '@/components/layout/modal/TransitionModal.vue'
import TooltipLayout from '@/components/layout/tooltip/TooltipLayout.vue'

const { tooltip, close, tooltipEl } = useTooltip()
</script>
